import { render, staticRenderFns } from "./CarouselSection.vue?vue&type=template&id=37042fe4&"
import script from "./CarouselSection.vue?vue&type=script&lang=js&"
export * from "./CarouselSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports